import { render, staticRenderFns } from "./LKPublicationsFormdataReport.vue?vue&type=template&id=59c163f4&scoped=true&"
import script from "./LKPublicationsFormdataReport.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataReport.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataReport.vue?vue&type=style&index=0&id=59c163f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c163f4",
  null
  
)

export default component.exports